export default "__VITE_ASSET__4b838b06__"